/** VARIABLES */
/************ */
const itemsArray = []; // Work in progress...
const BLOCK_PADDING = 24;
const DEVICE_BREAK_POINT = 992;

/** GETTERS */
/********** */
/**
 * Get the height of an element
 * @param {HTMLELement} el
 * @returns Element Height
 */
const getElementHeight = (el) => {
  return el ? `${el.offsetHeight || el.clientHeight}` : null;
};

/** SETTERS */
/********** */
/**
 *
 * @param {HTMLElement} $container - setting the height of the targeted parent based on the ${total}
 * @param {HTMLElement} $buttonContainer - the container for the accordion & tab buttons
 * @param {HTMLElement} $contentContainer - the container for the accordion & tab content
 */
function setContainerHeight($container, $buttonContainer, $contentContainer) {
  let windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (windowWidth < DEVICE_BREAK_POINT) {
    return;
  }
  const buttonContainerHeight = getElementHeight($buttonContainer);
  const contentContainerHeight = getElementHeight($contentContainer);
  const totalHeight =
    Number(buttonContainerHeight) +
    Number(contentContainerHeight) +
    BLOCK_PADDING;
  $container.style.height = `${totalHeight}px`;
}

function setInactiveTabs(tabButtons, activeTabButton, activeTabContent) {
  tabButtons.forEach((button) => {
    !button.classList.contains(activeTabButton)
      ? button.classList.remove('active')
      : null;
    !button.nextElementSibling.classList.contains(activeTabContent)
      ? button.nextElementSibling.classList.remove('active')
      : null;
  });
}

/**
 * Set the Clicked Accordion Item Open
 * @param {HTMLElement} content
 */
function setAccordionItemOpen(content) {
  content.style.maxHeight = content.scrollHeight + 'px';
  // content.style.visibility = 'visible';
}

/**
 * Set the Clicked Accordion Item Closed
 * @param {HTMLElement} content
 */
function setAccordionItemClosed(content) {
  content.style.maxHeight = null;
  // content.style.visibility = 'hidden';
}

/**
 * Set the Active Tab
 * @param {HTMLElement} activeTabButton
 * @param {HTMLElement} activeTabContent
 */
function setActiveTab(activeTabButton, activeTabContent) {
  activeTabButton.classList.add('active');
  activeTabContent.classList.add('active');
}

/** EVENTS & HANDLERS */
/*********** */
/**
 * Accordion - is the overarching function for the Mobile Events
 * Note: the mobile and desktop events are different for this module
 */
function handleMobileAccordion($container) {
  const selectors = {
    $container: $container,
    $accordionContent: this.nextElementSibling,
  };
  if (selectors.$accordionContent.classList.contains('visible-on-load')) {
    this.classList.toggle('active');
    selectors.$accordionContent.classList.toggle('active');
    selectors.$accordionContent.classList.remove('visible-on-load');
    setAccordionItemClosed(selectors.$accordionContent);
  } else {
    this.classList.toggle('active');
    if (selectors.$accordionContent.style.maxHeight) {
      setAccordionItemClosed(selectors.$accordionContent);
    } else {
      setAccordionItemOpen(selectors.$accordionContent);
    }
  }
  // Reset the Container Height
  $container.style.height = 'auto';
}

/**
 * Tabs - is the overarching function for the Desktop Events
 * Within the Tabs we want to do the following:
 * Set an Active Tab on Click and Unset other tabs
 * Prevent Clicking on Active Tab
 * Note: the desktop and mobile events are different for this module
 */
function handleDesktopTabs($container) {
  const selectedTabNumber = this.dataset.productTab;
  const selectors = {
    $container: $container,
    $containerInner: $container.querySelector('.product-tabs__inner'),
    $activeTabButtonClassname: `product-tabs__item--${selectedTabNumber}`,
    $activeTabContentClassname: `product-tabs__item-panel--${selectedTabNumber}`,
    $tabButtons: $container.querySelectorAll(`.product-tabs__item`),
    $activeTabButton: $container.querySelector(
      `.product-tabs__item--${selectedTabNumber}`
    ),
    $activeTabContent: $container.querySelector(
      `.product-tabs__item-panel--${selectedTabNumber}`
    ),
  };

  // Once the Tab is Clicked we want to set Inactive Tabs and then set the Active Tab
  setInactiveTabs(
    selectors.$tabButtons,
    selectors.$activeTabButtonClassname,
    selectors.$activeTabContentClassname
  );
  setActiveTab(selectors.$activeTabButton, selectors.$activeTabContent);

  // Resize the Parent Container
  setContainerHeight(
    selectors.$container,
    selectors.$containerInner,
    selectors.$activeTabContent
  );
}

/**
 * Handle Click Events - Bind correct events based on viewport width
 * @param { Array of HTMLElements } elements - Array of HTML Elements
 * @param { func } mobileEvent - function to execute on mobile view
 * @param { func } desktopEvent - function to execute on desktop view
 */
function handleClickEvents($container, elements, mobileEvent, desktopEvent) {
  let windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const options = {
    passive: true,
  };

  elements.forEach((el, index) => {
    if (windowWidth > DEVICE_BREAK_POINT) {
      if (!itemsArray[index].hasDesktopBoundEvent) {
        el.addEventListener(
          'click',
          desktopEvent.bind(el, $container),
          options
        );
        itemsArray[index].hasDesktopBoundEvent = true;
      } else {
        el.removeEventListener('click', mobileEvent.bind(el), true);
        itemsArray[index].hasMobileBoundEvent = false;
      }
    } else {
      if (!itemsArray[index].hasMobileBoundEvent) {
        el.addEventListener('click', mobileEvent.bind(el, $container), options);
        itemsArray[index].hasMobileBoundEvent = true;
      } else {
        el.removeEventListener('click', desktopEvent.bind(el), true);
        el.removeEventListener('click', desktopEvent, true);
        itemsArray[index].hasDesktopBoundEvent = false;
      }
    }
  });
}

/** EXPORTS */
export function InitProductTabs(selectors) {
  const { $container, $innerContainer, $items, $activeContentPanel } =
    selectors;
  let resizeTimer;
  window.addEventListener(
    'resize',
    () => {
      const $activeContentPanel = document.querySelector(
        '.product-tabs__item-panel.active'
      );
      setContainerHeight($container, $innerContainer, $activeContentPanel);

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        handleClickEvents(
          $container,
          $items,
          handleMobileAccordion,
          handleDesktopTabs
        );
      }, 250);
    },
    false
  );

  window.addEventListener('load', () => {
    $container.classList.add('is-loaded');
    $items.forEach((el) => itemsArray.push({ $element: el }));
    handleClickEvents(
      $container,
      $items,
      handleMobileAccordion,
      handleDesktopTabs
    );
    setContainerHeight($container, $innerContainer, $activeContentPanel);
  });
}
